import { Divider, Typography, FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import React, { FC, useState } from 'react';
import { useEditLab } from '../../../context/edit-lab-context';
import { useTranslation } from 'react-i18next';

const ActiveActionSet: FC = () => {
    const { t: translate } = useTranslation(['common', 'organization', 'orders', 'manage-actions']);
    const { actionSets, actionSetActiveForDisplay, isLoading, setActiveActionSet } = useEditLab();
    const [selectedAction, setSelectedAction] = useState('');

    if (isLoading) return <Typography>{translate('organization:LOADING')}...</Typography>;
    if (!actionSets) return <Typography>{translate('organization:NO_ACTION_SETS_DATA')}</Typography>;

    const handleActionSetChange = (selectedActionSetId: string) => {
        setSelectedAction(selectedActionSetId);
        setActiveActionSet(selectedActionSetId);
    };
    return (
        <>
            <Divider sx={{ mt: 3, mb: 3 }} />
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
                    <FormControl sx={{ width: '50%', minWidth: 250 }}>
                        <InputLabel>{translate('manage-actions:ACTION_SET')}</InputLabel>
                        <Select
                            value={selectedAction || actionSetActiveForDisplay?._id || ''}
                            label={translate('manage-actions:ACTION_SET')}
                            onChange={(e) => handleActionSetChange(e.target.value)}
                        >
                            {actionSets.map((action) => (
                                <MenuItem key={action._id} value={action._id}>
                                    {action.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="body1" color="primary" sx={{ fontWeight: 500 }}>
                        {translate('manage-actions:ACTIVE_ACTION_SET')}: {actionSetActiveForDisplay?.title || '-'}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default ActiveActionSet;
